import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { StripeService } from '../../../../services/stripe.service';
import { Salon } from '../../../../models';
import { UserService } from '../../../../services/user.service';
import { firstValueFrom } from 'rxjs';
import has = Reflect.has;

@Component({
  selector: 'smr-register-card-reader',
  templateUrl: './register-card-reader.component.html',
  styleUrls: ['./register-card-reader.component.scss'],
})
export class RegisterCardReaderComponent implements OnInit {
  public salon: Salon;
  public modal: boolean;
  public submitAttempt: boolean;
  public registerSuccessful: boolean;
  public registerUnsuccessful: boolean;
  public p400Device: boolean = false;
  public wisePosEDevice: boolean = false;
  public cardReaderConnected: boolean = false;

  public registerTerminalHeader: string;

  public terminalCode: string;

  constructor(
    private navParams: NavParams,
    private userService: UserService,
    private modalCtrl: ModalController,
    private stripeService: StripeService,
    private ref: ChangeDetectorRef
  ) {
    this.salon = userService.getSalon().clone();
    this.submitAttempt = false;
    this.terminalCode = '';
    this.registerTerminalHeader = 'Register card reader';
    this.registerSuccessful = false;
    this.registerUnsuccessful = false;
    // this.modal = (this.navParams.get('modal') !== undefined) ? this.navParams.get('modal') : false;
  }

  public ngOnInit() {}

  public async submitCode() {
    if (this.terminalCode === '') {
      return;
    }
    this.cardReaderConnected = false;
    this.p400Device = false;
    this.wisePosEDevice = false;
    this.registerSuccessful = false;
    this.registerUnsuccessful = false;
    this.submitAttempt = true;
    let hasAddress: boolean = false;
    let locationID = await firstValueFrom(
      this.stripeService.getStripeLocation()
    );
    if (locationID) {
      hasAddress = true;
    }
    let country;
    this.salon.getCountry().getCountryName() === 'Canada'
      ? (country = 'CA')
      : (country = 'US');
    const address = {
      line1: this.salon.getAddress1(),
      city: this.salon.getCity(),
      state: this.salon.getProvince(),
      country,
      postal_code: this.salon.getPostal(),
    };
    this.stripeService
      .registerNewTerminal(this.terminalCode, hasAddress, address, locationID)
      .subscribe({
        next: async (registeredTerminal) => {
          this.submitAttempt = false;
          this.registerTerminalHeader = 'Registration Successful';
          this.registerSuccessful = true;
          if (registeredTerminal['device_type'] === 'verifone_P400') {
            this.p400Device = true;
          }
          if (registeredTerminal['device_type'] === 'bbpos_wisepos_e') {
            this.wisePosEDevice = true;
          }
          localStorage.setItem(
            'cardReader',
            JSON.stringify(registeredTerminal)
          );
          this.cardReaderConnected = true;
          this.ref.detectChanges();
        },
        error: (error) => {
          this.submitAttempt = false;
          this.terminalCode = '';
          this.registerTerminalHeader = 'Register card reader';
          this.registerUnsuccessful = true;
          this.ref.detectChanges();
        },
      });
  }

  public async continue() {
    this.registerSuccessful = false;
    await this.onDismiss();
  }

  public async onDismiss() {
    if (this.modal) {
      await this.modalCtrl.dismiss(this.cardReaderConnected);
    }
  }
}
